// ============================================
// SCROLL LOCK
// The page behind an overlay with a backdrop (modals, the drawer) does not scroll.
// ============================================
//
// Both <html> and <body> are locked: when the page's scroller is <html> (CSS that gives it
// overflow-x does that), hiding only <body>'s overflow does not stop it. Each overlay takes its
// own lock by key, and the page scrolls again once none is left. The scrollbar's width is kept
// as padding, so the page does not shift sideways when the bar goes away.

const holders = new Set<string>();

export function lockScroll(key: string): void {
    if (holders.has(key)) return;

    if (!holders.size) {
        const html = document.documentElement;
        const scrollbar = window.innerWidth - html.clientWidth;
        html.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        if (scrollbar > 0) {
            document.body.style.paddingRight = scrollbar + 'px';
        }
    }

    holders.add(key);
}

export function unlockScroll(key: string): void {
    if (!holders.delete(key) || holders.size) return;

    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
}
